import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

function DataToolbar({
    shouldShowSegments,
    editMode,
    setEditMode,
    handleBulkTaskStatusChange,
    handleBulkSegmentStatusChange,
    selectedTaskName,
    refresh,
    showFilters,
    handleHomeClick,
}) {
    function onAcceptAll() {
        shouldShowSegments
            ? handleBulkSegmentStatusChange('ACCEPTED')
            : handleBulkTaskStatusChange('ACCEPTED');
    }

    function onRejectAll() {
        shouldShowSegments
            ? handleBulkSegmentStatusChange('REJECTED')
            : handleBulkTaskStatusChange('REJECTED');
    }

    const BreadcrumbGroup = () => {
        // const defaultBadgeProps = {
        //     color: 'primary',
        //     className: 'mx-2',
        // };

        return (
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                <Link color="inherit" onClick={handleHomeClick}>
                    Tasks{' '}
                    {/* TODO: enable this feature once a user has the ability to select more than one location at a time.
                        {shouldShowSegments && (
                            <Badge
                                badgeContent={locationSelectionModel.length || 1}
                                {...defaultBadgeProps}
                            />
                        )} 
                    */}
                </Link>
                {shouldShowSegments && (
                    <Typography color="textPrimary">
                        {shouldShowSegments && `${selectedTaskName} - `}
                        Segments
                    </Typography>
                )}
            </Breadcrumbs>
        );
    };

    return (
        <>
            <div className="col">
                <BreadcrumbGroup />
            </div>
            <div className="col"></div>
            <div className="col d-flex justify-content-end">
                {!shouldShowSegments && editMode ? (
                    <>
                        <button
                            className="btn btn-primary ml-2"
                            onClick={onAcceptAll}
                        >
                            Accept All Checked
                        </button>
                        <button
                            className="btn btn-primary ml-2"
                            onClick={onRejectAll}
                        >
                            Reject All Checked
                        </button>
                    </>
                ) : null}

                {editMode ? (
                    <button
                        className="btn btn-secondary ml-2"
                        onClick={() => setEditMode(false)}
                    >
                        Done
                    </button>
                ) : (
                    <button
                        className="btn btn-primary"
                        onClick={() => setEditMode(true)}
                    >
                        Edit
                    </button>
                )}

                {!shouldShowSegments ? (
                    <>
                        <button
                            className="btn btn-primary ml-2"
                            onClick={refresh}
                        >
                            Refresh
                        </button>
                        <button
                            className="btn btn-primary ml-2"
                            onClick={showFilters}
                        >
                            Filters
                        </button>
                    </>
                ) : null}
            </div>
        </>
    );
}

DataToolbar.propTypes = {
    shouldShowSegments: PropTypes.bool,
    editMode: PropTypes.bool,
    setEditMode: PropTypes.func,
    handleBulkTaskStatusChange: PropTypes.func,
    handleBulkSegmentStatusChange: PropTypes.func,
    selectedTaskName: PropTypes.string,
    refresh: PropTypes.func,
    showFilters: PropTypes.func,
    handleHomeClick: PropTypes.func,
};

DataToolbar.defaultProps = {
    shouldShowSegments: false,
    editMode: false,
};

export default DataToolbar;
